import { toast } from 'react-toastify';
import APIs from '../../apiUrl';

const CreateProduct = async (payload) => {
  try {
    const response = await APIs.post('/create_product', payload);
    console.log(response, 'response');

    if (response?.data?.message === 'success') {
      toast('Created Successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadProductImages = async (payload) => {
  try {
    const response = await APIs.post(
      `/cloudinary_multiple_file_upload`,
      payload
    );

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const uploadProductThu = async (payload) => {
  try {
    const response = await APIs.post(`/cloudinary_file_upload`, payload);

    if (response?.data?.message === 'success') {
      toast('successfully');
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllProduct = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_product/${payload?.page}/${payload?.limit}/${payload?.sortBy}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllProductById = async (payload) => {
  try {
    const response = await APIs.get(
      `/get_all_product_by_id/${payload?.id}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getSingleProductDetails = async (payload) => {
  try {
    const response = await APIs.get(`/get_single_product/${payload?.Id}`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const DeleteProduct = async (payload) => {
  try {
    const response = await APIs.post(`/delete_product`, payload);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const EditProduct = async (payload) => {
  try {
    const response = await APIs.patch(`/edit_product/${payload?._id}`, payload);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const getAllProductCount = async () => {
  try {
    const response = await APIs.get(`/get_all_product_count`);

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const SearchForProductByTitle = async (payload) => {
  try {
    const response = await APIs.get(
      `/search_for_product_by_title/${payload?.title}/${payload?.page}/${payload?.limit}`
    );

    if (response?.data?.message === 'success') {
      return response?.data;
    }
  } catch (error) {
    throw error;
  }
};

const ProductsServices = {
  CreateProduct,
  uploadProductImages,
  uploadProductThu,
  getAllProduct,
  getSingleProductDetails,
  DeleteProduct,
  EditProduct,
  getAllProductById,
  getAllProductCount,
  SearchForProductByTitle,
};

export default ProductsServices;
